import api from '../utils/api.js'

export default {
  state: {
    productInfo: {},
    allGoods: [],
    categories: [],
    apiErrorMessage: '',
    isLoading: false
  },
  getters: {
    getProductInfo: (state) => id => {
      if (!isNaN(+id)) {
        return state.allGoods.find(g => g.id === +id)
      } else {
        return state.allGoods[0]
      }
    },
    getAllGoods: (state) => {
      return state.allGoods
    },
    getLoadingState: (state) => {
      return state.isLoading
    }
  },
  mutations: {
    selectProduct (state, newInfo) {
      state.productInfo = newInfo
    },
    setGoods (state, goods) {
      state.allGoods = goods
    },
    setCategories (state, categories) {
      state.categories = categories
    },
    apiFailure (state, errorMessage) {
      state.apiErrorMessage = errorMessage
    },
    setIsLoading (state, value) {
      state.isLoading = value
    }
  },
  actions: {
    getAllCategories (context) {
      return api.get('https://old.dclink.ua/api/mikrotik/categories')
        .then(response => {
          context.commit('setCategories', response)
        })
        .catch(error => context.commit('apiFailure', error.message))
    },
    getInitialData (context) {
      return context.dispatch('getAllCategories').then(() => {
        return context.dispatch('getGoodsByCategories', [])
      })
    },
    getGoodsByCategories (context, categoriesVal) {
      const body = {
        categories: categoriesVal && categoriesVal.length !== 0 ? categoriesVal : []
      }

      return api.post('https://old.dclink.ua/api/mikrotik/goods', body)
        .then(response => {
          context.commit('setGoods', Array.from(new Set(response.data)))
        })
        .catch(error => {
          context.commit('apiFailure', error.message)
        })
    },
    sendFeedBack (context, data) {
      const body = {
        ...data
      }
      return api.post('https://old.dclink.ua/api/mikrotik/feedback', body)
        .then(response => {
          // console.log(response)
          return response
        })
        .catch(error => {
          // console.log(JSON.stringify(error))
          context.commit('apiFailure', error.message)
        })
    },
    getAllGoods ({ commit }) {
      commit('setProduct', [
        {
          name: 'Коммутатор',
          brandName: 'MikroTik',
          model: 'CSR125-24G-1S-2HND-IN',
          features: '(24x1G, 1x1G SFP, L3, WiFi)',
          imgSrc: 'https://eltex-co.ru/upload/iblock/ec7/MES3124F_fl.png'
        },
        {
          name: 'Коммутатор2',
          brandName: 'MikroTik',
          model: 'CSR125-24G-1S-2HND-IN',
          features: '(24x1G, 1x1G SFP, L3, WiFi)',
          imgSrc: 'https://eltex-co.ru/upload/iblock/ec7/MES3124F_fl.png'
        },
        {
          name: 'Коммутатор3',
          brandName: 'MikroTik',
          model: 'CSR125-24G-1S-2HND-IN',
          features: '(24x1G, 1x1G SFP, L3, WiFi)',
          imgSrc: 'https://eltex-co.ru/upload/iblock/ec7/MES3124F_fl.png'
        }
      ])
    },
    selectProduct ({ commit, state }, newInfo) {
      commit('selectProduct', newInfo)
    },
    setLoadingState (context, value) {
      context.commit('setIsLoading', value)
    }
  }
}
